import { useQueryClient, useMutation } from 'react-query';
import { useAxiosInstance } from '../common';

interface DeleteParams {
  fileNodeId: string,
  rootId: string
}

const useDeleteFileNode = (orgId: string) => {
  const axios = useAxiosInstance();
  const queryClient = useQueryClient();
  return useMutation(
    async (params: DeleteParams) => {
      const response = await axios.delete("filenode/" + params.fileNodeId + "/full");
      return response.data;
    },
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['rootStructure', orgId], { refetchInactive: true });
        queryClient.invalidateQueries(['fileNodeStructure', variables.rootId], { refetchInactive: true });
      },
    }
  );
};

export default useDeleteFileNode;